<template>
  <div  class="gain">
      <div class="gain-for mt-60">
        <div v-for="item, index in list" :key="index">
            <div class="gain-for-item">
                <div class="item-pic"><img class="item-pic-image" :src="getImgSrc(item)" alt=""></div>
                <b-row class="detail">
                    <b-col class="detail-date">
                        <div class="date-top">{{item.showDate?item.showDate.substring(0,7):''}}</div>
                        <div class="date-bottom">{{item.showDate?item.showDate.substring(8,10):''}}</div>
                    </b-col>
                    <b-col class="datail-text">
                        <div class="text-title">{{item.result_title}}</div>
                        <div class="text-num">
                          <div class="text-num-ci" >
                              <img class="icon-eye" src="../../assets/images/eye.png" alt="">
                              <span class="text-num-icon">浏览次数：{{item.access_count?item.access_count:0}}次</span>
                          </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="detal-explain1">
                    <div class="expain-row1 line4"><span v-html="item.result_content"></span></div>
                </b-row>
                <b-row  class="detal-explain3">
                    <b-col cols="12" class="explain-right"><button @click="handleDetail(item.doc_id)" class="detal-button">查看详情</button></b-col>
                </b-row>
                <el-divider></el-divider>
                <div class="space"></div>
            </div>
        </div>
      </div>
</div>

</template>
<script>
export default {
  name: 'achievements-wrapper',
  props:{
    list: {
        type: Array,
        default: () => ([]),
    },
  },
  data () {
    return {}
  },
  methods: {
    handleDetail(val) {
      this.$emit('handleDetail', val)
    },
    // 获取图片地址
    getImgSrc(info){
        let srcSource = null
        let imgInfo
        if (typeof info.result_content === "string") {
            srcSource = info.result_content.match(/src="([^"]*)"/g);
        }
        if (srcSource) {
            let imgList = srcSource[0].split('src=')
            imgInfo = imgList[1].replace("\"","").replace("\"","")
        }
        return imgInfo
    },
  }

}
</script>
<style lang="scss" scoped>
@import './achievements.scss'
</style>
